// removed by extract-text-webpack-plugin
module.exports = {"container":"Checkbox-container-c01ede6d","containerLanding":"Checkbox-containerLanding-a9c8be01","checkmark":"Checkbox-checkmark-f0bd58ff","containerLabel":"Checkbox-containerLabel-4af83112","containerLandingDisabled":"Checkbox-containerLandingDisabled-115cbf52"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Checkbox.scss
// module id = 799
// module chunks = 0